<template>
  <button
    type="button"
    class="btn btn--heart"
    :class="{ active: active }"
    :title="offerTitle"
    @click.prevent.stop="active = !active"
  >
    <!-- prettier-ignore -->
    <svg
      class="btn__icon"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <g transform="translate(-611.000000, -3856.000000)" :fill="active ? '#ffffff' : 'transparent'" stroke="#FFFFFF" stroke-width="1.5">
          <g transform="translate(0.000000, 3181.000000)">
            <g transform="translate(611.000000, 675.000000)">
              <g transform="translate(3.000000, 4.000000)">
                <path d="M9,4.0375 C7.12575,-1.719125 0.5,0.010625 0.5,5.178625 C0.5,9.428625 7.773875,15.0195 9,15.93325 C10.226125,15.0195 17.5,9.4265 17.5,5.178625 C17.5,0.014875 10.87425,-1.714875 9,4.0375 Z"></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </button>
</template>

<script>
export default {
  name: 'FavoriteButton',
  props: {
    offerId: {
      type: String,
      required: true,
    },
    offerTitle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      state: null,
    };
  },
  computed: {
    active: {
      get() {
        return this.offerId && this.state;
      },
      async set(state) {
        if (this.state === state) {
          return;
        }
        let favorites = {};
        try {
          const localFavorites = localStorage.getItem('favorites') || '{}';
          favorites = JSON.parse(localFavorites);
        } catch (error) {}

        if (state) {
          favorites[this.offerId] = true;
          await this.axios.post('/api/favorites', { offerId: this.offerId });
        } else {
          favorites[this.offerId] && delete favorites[this.offerId];
          await this.axios.delete('/api/favorites/' + this.offerId);
        }

        localStorage.setItem('favorites', JSON.stringify(favorites));
        this.state = state;
        const event = new CustomEvent('favorites', { detail: { offerId: this.offerId, state: state } });
        window.dispatchEvent(event);
      },
    },
  },
  watch: {
    offerId() {
      this.updateFromLocalStrorage();
    },
  },
  mounted() {
    this.updateFromLocalStrorage();
    window.addEventListener('favorites', this.listenFavoritesEvent, false);
  },
  beforeDestroy() {
    window.removeEventListener('favorites', this.listenFavoritesEvent, false);
  },
  methods: {
    updateFromLocalStrorage() {
      let favorites = {};
      try {
        const localFavorites = localStorage.getItem('favorites') || '{}';
        favorites = JSON.parse(localFavorites);
      } catch (error) {}
      this.state = !!favorites[this.offerId];
    },
    listenFavoritesEvent(event) {
      if (event.detail.offerId !== this.offerId) {
        return;
      }
      this.state = event.detail.state;
    },
  },
};
</script>
